import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    nav: {
      home: '首页',
      introduce: '跨境联盟',
      service: '产品服务',
      news: '行业资讯',
      join: '合作加盟'
    },
    home: {
      title: '跨境全产业链资源整合',
      subtitle: '提供一站式跨境解决方案',
      slogan: '跨境简单 简单跨境',
      more: '点击了解详情',
      moreTip: '也许您还想了解更详细全面的内容',
      brandImageAlt: '品牌图片',
    },
    introduce: {
      title: '跨境联盟',
      itemsShow: '进口产品OEM/ODM服务流程',
      desc: '跨境联盟作为跨境电商生态链服务平台，整合跨境全产业链资源，集海关保税仓储、跨境清关、跨境支付、跨境物流等一系列跨境电商配套服务，打通海外资源，为海外厂商、实体电商、消费者在跨境电商领域提供从入门到进阶的一站式跨境解决方案。',
      time: '成立时间',
      enterprise: '服务企业',
      brand: '合作品牌',
      sku: 'SKU数',
      platform: '全产业链生态平台',
      warehouse: '联盟中央仓',
      service: '跨境电商配套服务',
      oem: 'OEM 一站式服务',
      partners: '部分合作品牌',
      partnersEnter: '品牌合作入口',
      mall: '商城小程序',
      mallDesc1: '货源无忧，品类齐全，快速搭建自由跨境电商平台',
      mallDesc2: '对接跨境联盟中央仓系统平台，支持多种社交零售场景，深耕私域激活粉丝',
      functionsNumber: '20+项',
      functions: '功能模块',
      funcList: [
        '商品管理',
        '分销管理',
        '系统管理',
        '订单管理',
        '自定义装修',
        '数据分析'
      ],
      support: '运营支持',
      supportList: [
        '库存共享',
        '素材共享',
        '选品中心',
        '一键上架',
        '一键代发',
        '分账系统',
        '价格管控'
      ],
      oemTitle: '跨境电商OEM',
      factory: '专业的源头工厂',
      factoryDesc1: '汇聚天然营养，优选核心科技，共享品质生活。',
      factoryDesc2: '跨境OEM一站式服务。',
      factoryFrom: '我们的源头工厂来自于：',
      countries: [
        '新西兰', '澳大利亚', '韩国', '德国', '日本',
        '加拿大', '美国', '比利时', '荷兰', '瑞士',
        '法国', '俄罗斯', '印度', '丹麦', '西班牙'
      ],
      note: '此处仅为跨境联盟合作部分国家展示（排名不分先后）',
      advantage: '卓越的竞争优势',
      advantages: [
        '十万级净化车间',
        '纯天然原材料',
        '技术研发与质检',
        '自定义包装'
      ],
      category: '生产加工产品类别',
      categoryDesc: '共享全球核心技术与剂型，产品剂型有软胶囊、硬胶囊、滴剂、水剂、粉剂、片剂、蜂蜜等，力求满足各种需求。',
      products: [
        '高钙奶制品',
        '儿童补充剂',
        '成人保健品',
        '健康膳食'
      ],
      joinTitle: '合作加盟',
      joinItems: [
        '进口产品 OEM/ODM',
        '跨境商品货源',
        '跨境商品销售渠道',
        '跨境商城小程序',
        '跨境商品清关'
      ],
      faqs: [
        '跨境进口电商需要哪些资质',
        '跨境商品个人消费需要注意事项',
        '海关对跨境商品如何监管',
        '如何搭建跨境商城小程序'
      ],
      faqsTitle: '跨境常见问题',
    },
    footer: {
      addr1: '福建省厦门市湖里区海西金融广场9F',
      addr2: '福建省福州市台江区鳌兴时代5F',
      about: '关于跨境联盟',
      services: [
        '跨境电商解决方案',
        '跨境电商小程序',
        '跨境中央仓系统',
        '跨境合作加盟',
        '跨境电商配套服务',
        '跨境电商OEM',
        '跨境新媒体运营',
        '活力联盟'
      ],
      tags: '跨境、平台、货源、OEM',
      find: '找跨境联盟',
      company: '跨境联盟',
      companyDesc: '跨境联盟作为跨境电商生态链服务平台，在厦门海关的关心和支持下于2016年成立，推动跨境电商+实体产业的进出口双向发展。跨境联盟成立以来一直致力于国际电商资源的聚集、优化与整合！对跨境电商领域全球资源——包括海外厂商、海外仓、保税仓、物流、清关、支付、金融供应链，配送等等一系列优势资源的高度聚集、优化与整合，从而针对电商企业面临的各种痛点问题以及发展瓶颈，建立了一整套专业化、全方位的电商服务解决方案与服务体系！从而有的放矢，针对性，诊断式、系统性的帮助电商企业实现全面突破与质的飞跃。',
      servicesList: [
        '资质申请',
        '税务合规',
        '关税逆算',
        '保税仓储',
        '跨境清关',
        '跨境支付',
        '跨境物流',
        '分包分捡',
        '系统搭建',
        '海关对接',
        '跨境电商政策'
      ],
      oemProcess: '跨境电商OEM一站式服务',
      suppliers: '合作的400多家供应商',
      districts: '分布在37个关区',
      warehouses: '分布在52个保税仓',
      factorySelect: '海外工厂选择',
      customs: '入关入保税仓',
      bonded: '跨境保税电商服务',
      certificate: '软件平台证书',
      allService: '跨境联盟拥有一支专业跨境电商技术团队，主要负责跨境进口、跨境出口系统搭建。已完成了跨境中央仓系统、跨境物流清关系统、跨境商城系统。这三套系统为海外厂商、电商企业、消费者之间起到了一个重要桥梁作用，将三方紧密的连在一起，形成一条环环相扣的供应链体系。'
    },
    contact: {
      title: '您想了解更多跨境电商相关业务吗？',
      options: [
        '品牌厂商',
        '商家渠道',
        '团队/个人'
      ],
      news: '行业资讯',
      newsDesc: '了解跨境行业最新动态资讯',
      newsTypes: [
        '新闻资讯',
        '公司新闻',
        '行业资讯',
        '常见问题'
      ],
      joinDesc1: '在这个充满机遇与挑战的时代，您是否渴望拥有一份属于自己的成功事业？',
      joinDesc2: '是否期待与一个强大的品牌携手共进，实现财富与梦想的双重丰收？',
      joinDesc3: '现在，机会！来了',
      joinDesc4: '跨境联盟诚邀您加入我们的合作加盟大家庭，共同开启璀璨未来！',
      tel: '联系电话：Tel: +86-13959244873 （张经理）（Miss Zhang）',
      email: '邮箱：Email:',
      tiktok: 'Tiktok：',
      contactUs: '联系我们',
      click: '请点击下列选项',
      xiamen: '跨境联盟（厦门总部）',
      xiamenAddr: '地址：福建省厦门市湖里区海西金融广场9F',
      fuzhou: '跨境联盟(福州分公司)',
      fuzhouAddr: '地址：福建省福州市台江区鳌兴时代5F'
    },
    companyIntroduction: {
      joinDesc1: '在这个充满机遇与挑战的时代，您是否渴望拥有一份属于自己的成功事业？',
      joinDesc2: '是否期待与一个强大的品牌携手共进，实现<span>财富</span>与<span>梦想</span>的双重丰收？',
      joinDesc3: '现在，<span>机会！</span>来了',
      joinDesc4: '跨境联盟诚邀您加入我们的合作加盟大家庭，共同开启<span>璀璨未来</span>！',
      contactUs: '联系我们',
      xiamen: '跨境联盟',
      xiamenAddr: '地址：福建省厦门市湖里区海西金融广场9F',
      fuzhou: '跨境联盟',
      fuzhouAddr: '地址：福建省福州市台江区鳌兴时代5F',
      xiamenHeadquarters: '(厦门总部)',
      fuzhouBranch: '(福州分公司)',
      tel: '联系电话：',
      phone: '13959244873（张经理）',
      qrCodeAlt: '二维码',
      email: '邮箱：',
      emailAddress: 'kjlmxm@yeah.net',
    },
    newsInformation: {
      news: '新闻资讯',
      companyNews: '公司新闻',
      industryNews: '行业资讯',
      faq: '常见问题'
    },
    header: {
      dialogTitle: '提示',
      scanQrCode: '请扫描下面二维码联系我们',
      contactQrCodeAlt: '联系二维码',
      cancel: '取 消',
      confirm: '确 定'
    },
    service: {
      centerSystemTip: '跨境全流程对接，提供跨境业务一站式服务',
      centerServer: [
        '商品上架',
        '保税仓对接',
        '海关对接',
        '海外仓支付',
        '跨境支付',
        '订单推送',
        '物流对接',
        '供应结算'
      ]
    }
  },
  'en': {
    nav: {
      home: 'Home',
      introduce: 'Introduce',
      service: 'Service',
      news: 'News',
      join: 'Join us'
    },
    home: {
      title: 'Cross-border Full Industrial Chain Resource Integration',
      subtitle: 'Provide One-stop Cross-border Solutions',
      slogan: 'Cross-border Made Simple, Simple Cross-border',
      more: 'Learn more',
      brandImageAlt: 'Brand Image',
      moreTip: 'Maybe you would like to know more detailed and comprehensive content'
    },
    introduce: {
      itemsShow: "Imported Products OEM/ODM Service Process",
      faqsTitle:'Common Cross-border Questions',
      title: 'CROSS-BORDER UNION',
      desc: 'As a service platform for the cross-border e-commerce ecosystem, the CROSS-BORDER UNION integrates resources across the entire cross-border industrial chain. It encompasses a full range of supporting services for cross-border e-commerce, including customs bonded warehousing, cross-border customs clearance, cross-border payment, and cross-border logistics. It connects overseas resources and provides one-stop cross-border solutions—covering both entry-level and advanced needs—for overseas manufacturers, physical e-commerce businesses, and consumers in the cross-border e-commerce sector.',
      time: 'Establishment Time',
      enterprise: 'Enterprises Served',
      brand: 'Cooperative brands',
      sku: 'Number of SKUs',
      platform: 'Full Industrial Chain Ecological Platform',
      warehouse: 'UNION Central Warehouse',
      service: 'Cross-border E-commerce Supporting Services',
      oem: 'One-stop OEM Services',
      partners: 'Parts of cooperative enterprises',
      partnersEnter: 'Brand cooperation entrance',
      mall: 'Mall Mini Program',
      mallDesc1: 'Worry-free supply, complete product categories, and quickly build an independent cross-border e-commerce platform.',
      mallDesc2: 'Connect to the Cross-border UNION Central Warehouse System Platform, support various social retail scenarios, and deeply cultivate private domains to activate consumers.',
      functionsNumber: '20+ ',
      functions: 'Functions',
      funcList: [
        'Product Management',
        'Distribution Management',
        'System Management',
        'Order Management',
        'Custom Decoration',
        'Data Analysis'
      ],
      support: 'Operations Support',
      supportList: [
        'Inventory Sharing',
        'Material Sharing',
        'Product Selection Center',
        'One-click Listing',
        'One-click Dropshipping',
        'Revenue Sharing System',
        'Price Control'
      ],
      oemTitle: 'Cross-border E-commerce OEM',
      factory: 'Professional Source Factory',
      factoryDesc1: 'Gather natural nutrition, select core technology, and share quality life',
      factoryDesc2: 'Cross-border One-stop OEM Services',
      factoryFrom: 'Our source factories come from:',
      countries: [
        'New Zealand', 'Australia', 'Korea', 'Germany', 'Japan',
        'Canada', 'America', 'Belgium', 'Holland', 'Switzerland',
        'France', 'Russia', 'India', 'Denmark', 'Spain'
      ],
      note: 'Only some countries partnered by the Cross-border UNION for OEM source factories are shown here (The order is unranked).',
      advantage: 'Outstanding Competitive Advantages',
      advantages: [
        '100,000-class Clean Workshop',
        'Natural Raw Materials',
        'R&D and Quality Inspection',
        'Customized Packaging'
      ],
      category: 'Production and Processing Product Categories',
      categoryDesc: 'Share core technologies and dosage forms worldwide. The product dosage forms include soft capsules, hard capsules, drops, liquid preparations, powders, tablets, and honey, striving to meet various needs.',
      products: [
        'High-Calcium Dairy Products',
        'Children\'s Supplements',
        'Adult Health Supplements',
        'Healthy Dietary Products'
      ],
      joinTitle: 'Cooperation and Franchise',
      joinItems: [
        'OEM/ODM Imported Products OEM/ODM',
        'Cross-border Commodity Supply Sources',
        'Cross-border Commodity Sales Channels',
        'Cross-border Mall Mini Program',
        'Cross-border Commodity Customs Clearance'
      ],
      faqs: [
        'What qualifications are required for cross-border import e-commerce?',
        'What precautions should individuals take when consuming cross-border goods?',
        'How does customs regulate cross-border goods?',
        'How to build a cross-border mall mini-program?'
      ]
    },
    footer: {
      addr1: '9F, Haixi Financial Plaza, Huli District, Xiamen City, Fujian Province',
      addr2: '5F, Aoxing times, Taijiang District, Fuzhou City, Fujian Province',
      about: 'About Cross-border UNION',
      services: [
        'Cross-border E-commerce Solutions',
        'Cross-border E-commerce Mini Program',
        'CROSS-BORDER UNION Central Warehouse System',
        'Cross-border Cooperation and Franchise',
        'Cross-border E-commerce Supporting Services',
        'Cross-border E-commerce OEM',
        'Cross-border New Media Operations',
        'Vigounion'
      ],
      tags: 'Cross-border, Platforms, Supply Sources, OEM',
      find: 'Find Cross-border UNION',
      company: 'Cross-border UNION',
      companyDesc: 'As a cross-border e-commerce ecological chain service platform, Cross-border UNION was founded in 2016 with the care and support of Xiamen Customs. It promotes the two-way import and export development of cross-border e-commerce + real economy industries. Since its establishment, Cross-border UNION has been committed to gathering, optimizing and integrating international e-commerce resources. It highly aggregates, optimizes and integrates global resources in the cross-border e-commerce field, including overseas manufacturers, overseas warehouses, bonded warehouses, logistics, customs clearance, payment, financial supply chain, distribution and more. To address various pain points and development bottlenecks faced by e-commerce enterprises, it has established a complete set of professional and comprehensive e-commerce service solutions and service systems. Thus, it helps e-commerce enterprises achieve comprehensive breakthroughs and qualitative leaps in a targeted, diagnostic and systematic manner.',
      servicesList: [
        'Qualification Application',
        'Tax Compliance',
        'Tariff Reverse Calculation',
        'Bonded Warehousing',
        'Cross-border Customs Clearance',
        'Cross-border Payment',
        'Cross-border logistics',
        'Sub-packaging and Sorting',
        'System Construction',
        'Customs Docking',
        'Cross-border E-commerce Policies'
      ],
      oemProcess: 'Cross-border E-commerce OEM One-stop Services',
      suppliers: 'Over 400 Cooperative Suppliers',
      districts: 'Distributed in 37 Customs Districts',
      warehouses: 'Distributed in 52 Bonded Warehouses',
      factorySelect: 'Overseas Factory Selection',
      customs: 'Customs Entry and Bonded Warehouse Placement',
      bonded: 'Cross-border Bonded E-commerce Services',
      certificate: 'Software Platform Certificate',
      allService: 'CROSS-BORDER UNION has a professional cross-border e-commerce technical team, mainly responsible for building cross-border import and export systems. It has completed three systems: the Cross-border Central Warehouse System, the Cross-border Logistics and Customs Clearance System, and the Cross-border Mall System. These three systems serve as an important bridge among overseas manufacturers, e-commerce enterprises, and consumers, closely connecting the three parties to form an interconnected supply chain system.',
      qrCodeAlt: 'Cross-border UNION QR Code'
    },
    contact: {
      title: 'Do you want to learn more about cross-border e-commerce-related businesses?',
      click: 'Please click on the following options',
      options: [
        'Brand Manufacturers',
        'Merchant Channels',
        'Teams/Individuals'
      ],
      news: 'Industry News',
      newsDesc: 'Learn about the latest developments in cross-border industries',
      newsTypes: [
        'News & Updates',
        'Company News',
        'Industry Insights',
        'FAQs'
      ],
      joinDesc1: 'In this era full of opportunities and challenges, do you yearn to have your own successful career?',
      joinDesc2: 'Do you look forward to joining hands with a powerful brand to achieve dual success in wealth and dreams?',
      joinDesc3: 'Now, the opportunity is here!',
      joinDesc4: 'Cross-border UNION sincerely invites you to join our cooperative franchise family and jointly embark on a bright future!',
      tel: 'Tel: +86-13959244873 (Manager Zhang) (Miss Zhang)',
      email: 'Email:',
      tiktok: 'Tiktok:',
      contactUs: 'Contact Us',
      xiamen: 'Cross-border UNION (Xiamen Headquarters)',
      xiamenAddr: 'Address: 9F, Haixi Financial Plaza, Huli District, Xiamen City, Fujian Province',
      fuzhou: 'Cross-border UNION (Fuzhou Branch Office)',
      fuzhouAddr: 'Address: 5F, Aoxing times, Taijiang District, Fuzhou City, Fujian Province'
    },
    companyIntroduction: {
      joinDesc1: 'In this era full of opportunities and challenges, do you yearn to have your own successful career?',
      joinDesc2: 'Do you look forward to joining hands with a powerful brand to achieve dual success in <span>wealth</span> and <span>dreams</span>?',
      joinDesc3: 'Now, the <span>opportunity</span> is here!',
      joinDesc4: 'Cross-border UNION sincerely invites you to join our cooperative franchise family and jointly embark on a <span>bright future</span>!',
      contactUs: 'Contact Us',
      xiamen: 'CROSS-BORDER UNION UNION',
      xiamenAddr: 'Address: 9F, Haixi Financial Plaza, Huli District, Xiamen City, Fujian Province',
      fuzhou: 'CROSS-BORDER UNION',
      fuzhouAddr: 'Address: 5F, Aoxing times, Taijiang District, Fuzhou City, Fujian Province',
      xiamenHeadquarters: '(Xiamen Headquarters)',
      fuzhouBranch: '(Fuzhou Branch Office)',
      tel: 'Tel:',
      phone: '+86-13959244873 (Miss Zhang)',
      qrCodeAlt: 'QR Code',
      email: 'Email:',
      emailAddress: 'kjlmxm@yeah.net',
    },
    newsInformation: {
      news: 'News & Updates',
      companyNews: 'Company News',
      industryNews: 'Industry Insights',
      faq: 'FAQs'
    },
    header: {
      dialogTitle: 'Notice',
      scanQrCode: 'Please scan the QR code below to contact us',
      contactQrCodeAlt: 'Contact QR Code',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    service: {
      centerSystemTip: 'Cross-border full-process docking, providing one-stop services for cross-border business',
      centerServer: [
        'Product Listing',
        'Bonded Warehouse Docking',
        'Customs Docking',
        'Overseas Warehouse Payment',
        'Cross-border Payment',
        'Order Push',
        'Logistics Docking',
        'Supply Settlement'
      ]
    }
  }
}

const i18n = new VueI18n({
  locale: 'zh-CN', // 设置默认语言
  messages, // 设置语言包
})

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js